import React, { ReactElement } from "react";
import { useTheme } from "styled-components";
import FlexBox from "ui/FlexBox";
import Body from "ui/Text/Body";
import Heading from "ui/Text/Heading";

interface Props {
  title: string;
  text: string;
  icon: ReactElement;
}

const ToastContent: React.FC<Props> = ({ title, text, icon }) => {
  const theme = useTheme();

  return (
    <FlexBox alignItems="center">
      {React.cloneElement(icon, { fill: theme.colors.text.secondary, width: 40 })}
      <div className="ml-sm">
        <Heading color="secondary" variant="h4">
          {title}
        </Heading>
        <Body color="secondary" variant="body5">
          {text}
        </Body>
      </div>
    </FlexBox>
  );
};

export default ToastContent;
